// @ts-ignore
import SiteIcon from '../../assets/img/icons-chaser/icon_site.png';
// @ts-ignore
import TwitterIcon from '../../assets/img/icons-chaser/icon_twitter.png';
// @ts-ignore
import FbIcon from '../../assets/img/icons-chaser/icon_fb.png';
// @ts-ignore
import YtIcon from '../../assets/img/icons-chaser/icon_youtube.png';
import React, { useEffect, useState } from 'react';
import { StormChaserService } from '../../services/stormChaser/stormChaserService';
import * as Constants from "../../constants"
import './modalVideo.css';
import { useSearchParams } from 'react-router-dom';

export const ModalVideo = (props: any) => {
    const data = props.data;
    const [address, setAddress] = useState<any[]>([]);
    const stormChaserService = new StormChaserService();
    const [searchParams, setSearchParams] = useSearchParams();
    
    const init = async () => {
        const key = searchParams.get("key");
        const addressData = await stormChaserService.getAddressData(data, key);
        setAddress(addressData);
    
    }
    useEffect(() => {
        init();
        const containerExists = document.getElementById('video-stream');
        if (containerExists) {
            var api = new Clappr.Player({
                source: data.HLS,
                parentId: '#video-stream',
                poster: data.Thumb,
                width: "100%",
                height: "100%",
                plugins: [CDNByeClapprPlugin],
                playback: {
                    hlsjsConfig: {
                        maxBufferSize: 0,
                        maxBufferLength: 10,
                        liveSyncDurationCount: 10,
                        p2pConfig: {
                            live: true,
                            announceLocation: 'us',
                            token: 'wmTIieBVg'
                        }
                    }
                }
            });
        }
        return () => {
            api.destroy();
        }
    }, []);

    return (
        <div>
            <h4>{ data.User.FirstName + ' ' + data.User.LastName }</h4>
            <div id={'video-stream'} className={'video-content'} ></div>
            { address ?? <div>{address} </div> }
            <p>{ `Viewers : ${ stormChaserService.getViewersCount(data) }` }</p>
            <p className="addr">To use on TV <a className="alert" href="#" onClick={ () => alert(Constants.ALERT_VIDEO_TV) }>click
                here</a> for licensing.</p>
            <div className={ 'social-content' }>
                <a href={ data.User.Url ?? '#' }><img src={ SiteIcon } alt={ 'Site Icon' }/></a>
                <a href={ 'https://www.twitter.com/' + data.User.Twitter ?? '' }><img src={ TwitterIcon }
                                                                                      alt={ 'Twitter Icon' }/></a>
                <a href={ data.User.Facebook ?? '#' }><img src={ FbIcon } alt={ ' Facebook Icon' }/></a>
                <a href={ data.User.YouTube ?? '#' }><img src={ YtIcon } alt={ 'Youtube Icon' }/></a>
            </div>
            { data.User.PayPal && data.User.PayPal != 'null' && (
                <div>
                    <a href={ data.User.PayPal ?? '#' }>❤ Donate to Chaser</a>
                </div>
            ) }

        </div>
    )
}
